import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { resetState } from '../js/actions/index';

import { Key } from 'react-bootstrap-icons';
import { Button } from "react-bootstrap";

function mapDispatchToProps(dispatch) {
  return {
    resetState: payload => dispatch(resetState(payload))
  };
}

class AuthErrorComponent extends React.Component {

  handleLogout = () => {
    this.props.resetState().then( () => {
        if(this.props.auth.mode === "restuarant") {
            this.props.history.push('/login/restaurant');
        } else {
            this.props.history.push('/login/supplier');
        }
    });
  }

  render() {
      return (
        <div className="mt-4 text-center">
          <Key size={64} className="mb-1 mr-1 text-danger" />
          <div>Authentication Error</div>
          <div className="mt-4">
            <Button variant="link" className="px-0" onClick={this.handleLogout}>
                Go to Login Page
            </Button>
          </div>
        </div>
      );
  }
}

const mapStateToProps = state => {
  const {auth} = state;
  return { auth: auth };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AuthErrorComponent));